import { gql } from "@apollo/client";

export const GET_MEASUREMENT_CONFIGS = gql`
  query MeasurementConfigs {
    measurementConfigs {
      category
      fullName
      description
      shortName
      nature
      support
      unique_identifier
      unit
      pythonClass
      color
      range {
        green
        yellow
        red
      }
      viewtypes
      iscustom
    }
  }
`;

export const GET_CUSTOM_MEASUREMENT_CONFIGS = gql`
  query CustomMeasurementConfigs {
    customMeasurementConfigs {
      _id
      category
      fullName
      shortName
      support
      nature
      unique_identifier
      unit
      pythonClass
      color
      range {
        green
        yellow
        red
      }
      viewtypes
      iscustom
    }
  }
`;

export const GET_CUSTOM_MEASUREMENT_CONFIG_BY_ID = gql`
  query CustomMeasurementConfigsByIds($ids: [String!]!) {
    customMeasurementConfigsByIds(ids: $ids) {
      _id
      category
      fullName
      shortName
      support
      nature
      unique_identifier
      unit
      pythonClass
      color
      range {
        green
        yellow
        red
      }
      viewtypes
      iscustom
    }
  }
`;
